import { ComponentType, LazyExoticComponent } from 'react';
import { lazyWithRetry } from 'services';

export type AppRoute = {
  path: string;
  component: LazyExoticComponent<ComponentType>;
};

export const ROUTES = Object.freeze({
  OPPORTUNITIES: '/opportunities',
  PROGRAMS: '/programs',
  HUB_POSTS: '/resources',
  PRODUCTS_SERVICES: '/products-services',
  EVENTS: '/events',
  OPPORTUNITY_PROGRAMS: '/opportunity-programs/:jobId',
  OPPORTUNITY_PROGRAMS_PAGE: '/opportunity-programs',
  RESOURCE_POST: '/resource-programs/:resourceId',
  EXPIRED_LINK_PAGE: '/expired-link',
});

const routes: Array<AppRoute> = [
  {
    path: ROUTES.OPPORTUNITIES,
    component: lazyWithRetry(() => import('pages/opportunities')),
  },
  {
    path: ROUTES.PROGRAMS,
    component: lazyWithRetry(() => import('pages/programs')),
  },
  {
    path: ROUTES.HUB_POSTS,
    component: lazyWithRetry(() => import('pages/hub-posts')),
  },
  {
    path: ROUTES.PRODUCTS_SERVICES,
    component: lazyWithRetry(() => import('pages/products-services')),
  },
  {
    path: ROUTES.EVENTS,
    component: lazyWithRetry(() => import('pages/events')),
  },
  {
    path: ROUTES.OPPORTUNITY_PROGRAMS,
    component: lazyWithRetry(() => import('pages/opportunity-programs')),
  },
  {
    path: ROUTES.RESOURCE_POST,
    component: lazyWithRetry(() => import('pages/resource-post')),
  },
  {
    path: ROUTES.EXPIRED_LINK_PAGE,
    component: lazyWithRetry(() => import('pages/expired-link')),
  },
];

export default routes;
